import { cn } from "@/lib/utils";

function GlobeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[19px] text-berry", className)}
      fill="none"
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.25 17.5a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
      <path
        d="M16.187 4.788a11.318 11.318 0 01-6.936 2.006 11.3 11.3 0 01-6.937-2.006M16.187 13.73a11.318 11.318 0 00-6.936-2.006 11.3 11.3 0 00-6.937 2.006"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
      <path
        d="M9.25 17.5c1.899 0 3.437-3.693 3.437-8.25C12.687 4.694 11.15 1 9.25 1 7.352 1 5.813 4.694 5.813 9.25c0 4.557 1.54 8.25 3.437 8.25z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export default GlobeIcon;
